import React from 'react';
import { useUserPickemsForPeriod } from '@/api/query/useLeaderboard';

interface UserPickemsListProps {
  userId: string;
  period: 'today' | 'week' | 'month' | 'year';
  weekOffset?: number;
  leagueCode?: string;
  isCurrentUser?: boolean;
}

export const UserPickemsList: React.FC<UserPickemsListProps> = ({
  userId,
  period,
  weekOffset = 0,
  leagueCode,
  isCurrentUser = false,
}) => {
  const { data, isLoading, error } = useUserPickemsForPeriod(
    userId,
    period,
    { weekOffset: weekOffset ?? 0 },
    leagueCode
  );

  if (isLoading) {
    return (
      <div className={`text-sm ${isCurrentUser ? 'text-white/70' : 'text-text-secondary'}`}>
        Loading pickems...
      </div>
    );
  }

  if (error) {
    return (
      <div className={`text-sm ${isCurrentUser ? 'text-white/70' : 'text-text-secondary'}`}>
        Failed to load pickems
      </div>
    );
  }

  if (!data?.pickems || data.pickems.length === 0) {
    return (
      <div className={`text-sm ${isCurrentUser ? 'text-white/70' : 'text-text-secondary'}`}>
        No pickems found for this period
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {data.pickems.map(pickem => (
        <div
          key={pickem.pickem_id}
          className={`grid grid-cols-3 gap-2 text-sm py-2 border-b ${
            isCurrentUser ? 'border-white/10' : 'border-border/10'
          } last:border-0`}
        >
          <span className={`truncate ${isCurrentUser ? 'text-white' : 'text-text-primary'}`}>
            {pickem.pickem_title}
          </span>
          <span
            className={`text-center ${isCurrentUser ? 'text-white/90' : 'text-text-secondary'}`}
          >
            #{pickem.rank}
          </span>
          <span
            className={`text-right font-medium ${isCurrentUser ? 'text-white' : 'text-text-primary'}`}
          >
            {pickem.points}pts
          </span>
        </div>
      ))}
    </div>
  );
};
